import { render, staticRenderFns } from "./nova.vue?vue&type=template&id=ce0f22b4"
import script from "./nova.vue?vue&type=script&lang=js"
export * from "./nova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports